import React from "react";
import SignUpComponent from "../../Common/SignUpComponent/SignUpComponent";
import "./sign-up-portal.style.scss";

export default function SignupPortal({closeIt}) {
  return (
    <div onClick={() => closeIt()} className="sign-up-portal-main">
      <div onClick={(e) => e.stopPropagation()} className="sign-up-portal-modal">
        <SignUpComponent indirect="candidate" modal={true} />
      </div>
    </div>
  );
}
